import { Dispatch } from 'react';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { UPDATE_STORE_GROUP } from '../constants/actions';
import { TStoreGroupActionTypes } from '../types';
import { IStoreGroup } from 'src/interfaces/storeGroup';

/**
 * Will update a store group by id
 *
 * @param {Dispatch<TStoreGroupActionTypes>} dispatch
 * @param {string} storeGroupId
 * @param {Partial<IStoreGroup>} storeGroup
 */
export const updateStoreGroup = async (
    dispatch: Dispatch<TStoreGroupActionTypes>,
    storeGroupId: string,
    storeGroup: Partial<IStoreGroup>
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await api.put(
            `/store-groups/${storeGroupId}`,
            { ...storeGroup },
            HEADERS()
        );
        dispatch({ type: UPDATE_STORE_GROUP, payload: res.data.data });
    } catch (error) {
        dispatch(handleError(error));
    }
};
